import { Box, Typography } from "@mui/material";
import { RetroButton } from "components/RetroButton";
import { DarkDrawer } from "components/TradeDrawer";
import { Value } from "components/Value";
import { formatPrice, toPurePrecision } from "lib/utils";
import useUserStoreV2, { DEFAULT_CACHED_SLIPPAGE } from "store/user-store-v2/useUserStoreV2";
import theme from "theme";
import { Mode } from "tradeConfigs";
import { toFixedIfNecessary } from "utils";
import BasicButton from "v2/components/Buttons/BasicButton";

export const ConfirmDrawer = ({
  mode,
  isOpen,
  inputUsd,
  targetTokenPrice,
  targetAmount,
  targetTokenSymbol,
  close,
  onConfirm,
}: {
  mode: Mode | "SEND";
  isOpen: boolean;
  inputUsd: number;
  targetTokenPrice: number;
  targetAmount: number;
  targetTokenSymbol: string;
  close: () => void;
  onConfirm: (slippage: number | undefined) => void;
}) => {
  const { preferences = { slippage: DEFAULT_CACHED_SLIPPAGE } } = useUserStoreV2();
  const { slippage } = preferences;

  return (
    <DarkDrawer open={isOpen} anchor="bottom" onClose={() => {}} sx={{ zIndex: 2000 }}>
      <Box>
        <Typography variant="mobile-h2">Confirm</Typography>
      </Box>
      <Box
        sx={{
          marginTop: "16px",
          marginBottom: "32px",
        }}>
        <Typography variant="mobile-body-m" color={theme.palette.text.secondary}>
          You are {mode === "SEND" ? "sending" : mode === "SELL" ? "selling" : "purchasing"} $
          {targetTokenSymbol} tokens with a total value of{" "}
          <Value variant="mobile-body-m" value={targetAmount} /> ${targetTokenSymbol} @$
          <Value variant="mobile-body-m" value={targetTokenPrice} />{" "}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "10px",
        }}>
        <BasicButton sx={{ width: "100%" }} variant="white" onClick={close}>
          <Typography variant="mobile-body-s-heavy">No</Typography>
        </BasicButton>
        <BasicButton sx={{ width: "100%" }} onClick={() => onConfirm(slippage)}>
          <Typography variant="mobile-body-s-heavy">Yes</Typography>
        </BasicButton>
      </Box>
    </DarkDrawer>
  );
};
